import React from 'react';
import PassengerManifestDesktop from './PassengerManifestDesktop';
import PassengerManifestMobile from './PassengerManifestMobile';

const PassengerManifest = () => {
  return (
    <div>
      <div className={`hidden lg:flex flex-col`}>
        <PassengerManifestDesktop />
      </div>
      <div className={`flex lg:hidden`}>
        <PassengerManifestMobile />
      </div>
    </div>
  );
};

export default PassengerManifest;
